import { useEffect } from 'react';
import { RequestStatus, isRequestFulfilled } from '../interface';
import { selectIsPaidPortalState } from '../selectors';
import { isPaidPortalThunk } from '../thunks/is-paid-portal.thunk';
import { getPortalId } from '../utils/getPortalId';
import { useAppDispatch, useAppSelector } from './index';
const useIsPaidPortal = () => {
  const portalId = getPortalId();
  const dispatch = useAppDispatch();
  const {
    isPaidPortal,
    status
  } = useAppSelector(selectIsPaidPortalState);
  useEffect(() => {
    if (status !== RequestStatus.IDLE) {
      return;
    }
    void dispatch(isPaidPortalThunk(portalId));
  }, [dispatch, portalId, status]);
  return {
    isPaidPortal: isPaidPortal !== null && isPaidPortal !== void 0 ? isPaidPortal : false,
    isPaidLoaded: isRequestFulfilled(status)
  };
};
export default useIsPaidPortal;